<template>
  <scoped>
    <label
      v-if="title"
      :for="id"
    >
      {{ title }}
    </label>
    <input
      :id="id"
      v-model="value"
      type="password"
    >
  </scoped>
</template>

<script setup lang="ts">
  import {useId} from "vue"

  defineProps({
    title: {
      default: null,
      required: false,
      type: String
    }
  })

  const id = useId()
  const value = defineModel("value", {
    default: null,
    required: true,
    type: String
  })
</script>

<style scoped>
  input[type = "password"] {
    background-color: var(--color-white);
    border-color: var(--theme-color-primary);
    border-radius: var(--border-radius-small);
    border-style: solid;
    border-width: var(--border-width-light);
    display: block;
    margin: 0.5em 0;
    padding: 0.5em;

    &:focus, &:hover {
      border-color: var(--color-grey);
    }
  }

  label {
    display: block;
    font-weight: bolder;
  }
</style>
